import { IExperienceTemplate } from '@dadohr/shared/domainTypes/experience';
import { useMemo } from 'react';
import { useCurrentUser } from '../../../../services/currentUser';
import { useAllTargetAudiences } from '../../../../services/targetAudience';
import {
  getTemplateAudienceCarriers,
  getUsedSegments,
  SegmentDescriptor
} from '../ExperienceTimeline/segmentFilter';

/**
 * The saved segments (Target Audiences) this template actually uses — one
 * descriptor per saved segment that at least one task / message / automation
 * audience was copied from. Matching is structural (rule deep-equality),
 * see segmentFilter.ts. `segments` is empty while the library is loading.
 */
export const useTemplateSegments = (
  tplData: Pick<IExperienceTemplate, 'tasks' | 'messages' | 'automations'>
): { segments: SegmentDescriptor[]; loading: boolean } => {
  const { org } = useCurrentUser();
  const [savedSegments, loading] = useAllTargetAudiences(org.id);
  const { tasks, messages, automations } = tplData;
  const segments = useMemo(
    () =>
      getUsedSegments(
        getTemplateAudienceCarriers({ tasks, messages, automations }),
        (savedSegments || []).map((d) => ({
          id: d.id,
          name: d.data.name,
          rule: d.data.rule
        }))
      ),
    [tasks, messages, automations, savedSegments]
  );
  return { segments, loading: !!loading };
};
